import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'normalize.css'
import 'element-ui/lib/theme-chalk/display.css';
import router from './router'
import axios from './utils/http'
import Loading from './utils/loading'
import 'hover.css'
import i18n from './i18n'
import brand from './branding'
// import { i18n } from '@/i18n';
import { BackTop,Affix,Button, Menu, MenuItem, Card, Row, Col, Tag, Tabs, TabPane, Form, FormItem, Input, CheckboxGroup, Checkbox, Select, Option, RadioGroup, Radio, Cascader } from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.component('Button', Button);
Vue.component('Menu', Menu);
Vue.component('MenuItem', MenuItem);
Vue.component('Card', Card);
Vue.component('Row', Row);
Vue.component('Col', Col);
Vue.component('Tag', Tag);
Vue.component('Tabs', Tabs);
Vue.component('TabPane', TabPane);
Vue.component('Form', Form);
Vue.component('FormItem', FormItem);
Vue.component('Input', Input);
Vue.component('CheckboxGroup', CheckboxGroup);
Vue.component('Checkbox', Checkbox);
Vue.component('Select', Select);
Vue.component('Option', Option);
Vue.component('RadioGroup', RadioGroup);
Vue.component('Radio', Radio);
Vue.component('Cascader', Cascader);
Vue.component('BackTop', BackTop);
Vue.component('Affix', Affix);

import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
Vue.component('CallMe', CallMe);
Vue.component('MobileCallme', MobileCallme);

Vue.config.productionTip = false
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

// new Vue({
//   i18n,
//   render: h => h(App)
// }).$mount('#app')



Vue.prototype.axios = axios
Vue.prototype.$loading = Loading
Vue.prototype.$brand = brand

new Vue({
  router,
  beforeCreate:() => {
    Vue.prototype.$bus = this
  },
  i18n,
  render: h => h(App),
}).$mount('#app')
